import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Timestamp } from 'firebase/firestore';

@Component({
  selector: 'app-accounting-addon-text',
  imports: [CommonModule, ReactiveFormsModule],
  standalone: true,
  template: `
    <div
      class="flex flex-col justify-start gap-x-6 pt-4 w-full"
      [formGroup]="accounting"
    >
      <div class="flex flex-col w-full pb-4">
        <h2 class="text-base font-semibold leading-7 text-gray-900">
          Accounting
        </h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">
          Abrechnnen oder Notiz hinzufügen.
        </p>
      </div>
      <!-- Billing Checkbox -->
      <div class="flex flex-row items-center gap-x-3 w-full py-2">
        <input
          id="billed"
          type="checkbox"
          [checked]="accounting.get('billed')?.value"
          (change)="onBilledChange($any($event.target).checked)"
          class="h-4 w-4 rounded border-gray-300 text-columbus-blue-600 focus:ring-columbus-blue-500"
        />
        <label for="billed" class="text-sm font-medium text-gray-700">
          Abgerechnet
        </label>
      </div>

      <!-- Billing Info (nur sichtbar wenn abgerechnet) -->
      <div
        *ngIf="accounting.get('billed')?.value"
        class="text-xs text-gray-500 mt-1 w-full py-2"
      >
        Abgerechnet von {{ accounting.get('userBilledName')?.value }} am
        {{
          accounting.get('dateBilled')?.value?.toDate()
            | date: 'dd.MM.yyyy HH:mm'
        }}
      </div>

      <div class="w-full flex justify-start py-2">
        <h2 class="block text-sm font-medium leading-6 text-gray-900">
          Accounting Note
        </h2>
      </div>
      <div class="flex flex-col gap-x-6 w-full">
        <!-- Location Input -->
        <div class="flex flex-col w-full">
          <label
            for="accounting"
            class=" hidden mb-2 text-sm font-medium text-gray-700"
            >Accounting Note...</label
          >
          <textarea
            id="accounting"
            type="text"
            rows="5"
            formControlName="note"
            class="text-sm sm:text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            placeholder="Buchhaltungsnotiz eingeben..."
          ></textarea>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class AccountingAddonTextComponent {
  @Input({ required: true }) accounting!: FormGroup;
  @Input({ required: true }) currentUser!: { id: string; name: string };

  onBilledChange(checked: boolean): void {
    if (checked) {
      this.accounting.patchValue({
        billed: true,
        dateBilled: Timestamp.now(),
        userBilledId: this.currentUser.id,
        userBilledName: this.currentUser.name,
      });
    } else {
      this.accounting.patchValue({
        billed: false,
        dateBilled: null,
        userBilledId: null,
        userBilledName: null,
      });
    }
  }
}
